"use client"


interface PurchaseProgressProps {
  min_purchase: number
  reached: boolean
  remaining: number
  currentAmount?: number
  reward?: string
}

export default function ProgressShippingCheckpoints({ min_purchase, reached, remaining, currentAmount, reward }: PurchaseProgressProps) {
  const steps = [
    { id: 1, label: "Start", amount: 0 },
    { id: 2, label: `${Math.floor(min_purchase * 0.33)}`, amount: Math.floor(min_purchase * 0.33) },
    { id: 3, label: `${Math.floor(min_purchase * 0.66)}`, amount: Math.floor(min_purchase * 0.66) },
    { id: 4, label: `${min_purchase}`, amount: min_purchase },
  ]

  const getCurrentStep = () => {
    if (reached) return 4
    const current = min_purchase - remaining
    if (current >= min_purchase * 0.66) return 3
    if (current >= min_purchase * 0.33) return 2
    return 1
  }

  const currentStep = getCurrentStep()

  return (
    <div className="w-full max-w-2xl mx-auto p-4 relative">
      {/* Status Summary */}
      <div className="text-center text-sm text-gray-700 mb-4">
        {reached ? (
          <span className="text-yellow-700 font-semibold">
            🎉 You’ve reached your {min_purchase} target!
          </span>
        ) : (
          <span>
            {remaining} more to unlock shipping discount at {min_purchase}
          </span>
        )}
        {currentAmount !== undefined && (
          <div className="text-xs text-gray-500 mt-1">Current: {currentAmount}</div>
        )}
      </div>

      {/* Progress Bar Container */}
      <div className="relative w-full h-3 bg-gray-200 rounded-full overflow-hidden mb-6">
        {/* Filled Bar */}
        <div
          className="h-full bg-yellow-400 transition-all duration-500"
          style={{
            width: `${Math.min((currentAmount! / min_purchase) * 100, 100)}%`,
          }}
        />

        {/* Step Markers */}
        {[0, 33, 66, 100].map((percent, index) => (
          <div
            key={index}
            className="absolute top-0 -translate-x-1/2 h-3 w-[2px] bg-white"
            style={{ left: `${percent}%` }}
          />
        ))}
      </div>

      {/* Step Labels */}
      <div className="flex justify-between text-xs text-gray-600 px-1">
        {[0, Math.floor(min_purchase * 0.33), Math.floor(min_purchase * 0.66), min_purchase].map(
          (amount, index) => (
            <span key={index}> {reward}</span>
          )
        )}
      </div>
    </div>



  )
}
